import { Route, Routes, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import { startParam } from "./lib/tg";
import Feed from "./pages/Feed";
import SessionDetail from "./pages/SessionDetail";
import Me from "./pages/Me";
import Kids from "./pages/Kids";
import History from "./pages/History";
import ParticipantDetail from "./pages/ParticipantDetail";
import TrainerCalendar from "./pages/trainer/Calendar";
import NewSession from "./pages/trainer/NewSession";
import SessionManage from "./pages/trainer/SessionManage";
import EditSession from "./pages/trainer/EditSession";
import People from "./pages/trainer/People";
import { ModeSwitcher } from "./components/ModeSwitcher";
import { ParentTabBar } from "./components/ParentTabBar";
import { TrainerTabBar } from "./components/TrainerTabBar";

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}

function Shell() {
  const { user, loading, error, mode, setMode } = useAuth();
  const navigate = useNavigate();
  const handledRef = useRef(false);

  // One-shot Telegram start_param handling (deep link → parent context).
  useEffect(() => {
    if (loading || !user || handledRef.current) return;
    handledRef.current = true;
    const sp = startParam();
    if (sp?.startsWith("session_")) {
      setMode("parent");
      navigate(`/session/${sp.slice("session_".length)}`, { replace: true });
    }
  }, [loading, user, navigate, setMode]);

  if (loading) {
    return <div className="flex h-full items-center justify-center text-tg-hint">Завантаження…</div>;
  }
  if (error || !user) {
    return (
      <div className="p-4 text-center">
        <h1 className="text-xl font-semibold mb-2">Не вдалося увійти</h1>
        <p className="text-tg-hint text-sm">{error ?? "Відкрийте застосунок через Telegram-бота."}</p>
      </div>
    );
  }

  return (
    <div className="min-h-full pb-24">
      {user.trainer_id && <ModeSwitcher />}
      <Routes>
        {mode === "trainer" ? (
          <>
            <Route path="/" element={<TrainerCalendar />} />
            <Route path="/t" element={<TrainerCalendar />} />
            <Route path="/t/new" element={<NewSession />} />
            <Route path="/t/session/:id" element={<SessionManage />} />
            <Route path="/t/session/:id/edit" element={<EditSession />} />
            <Route path="/t/people" element={<People />} />
            <Route path="/t/participant/:id" element={<ParticipantDetail />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Feed />} />
            <Route path="/session/:id" element={<SessionDetail />} />
            <Route path="/me" element={<Me />} />
            <Route path="/me/history" element={<History />} />
            <Route path="/me/kids" element={<Kids />} />
            <Route path="/me/kid/:id" element={<ParticipantDetail />} />
          </>
        )}
        <Route path="*" element={mode === "trainer" ? <TrainerCalendar /> : <Feed />} />
      </Routes>
      {mode === "parent" ? <ParentTabBar /> : <TrainerTabBar />}
    </div>
  );
}
